/**
 * @returns {Object}
 */
export function lowerThan() {
    
    return {
        require: 'ngModel',
        link: (scope, element, attr, ctrl) => {
            
            const validate = (value) => {
                
                const comparisonModel = attr.lowerThan;
                
                if (!value || !comparisonModel) {
                    
                    ctrl.$setValidity('lowerThan', true);
                    
                } else {
                    
                    ctrl.$setValidity('lowerThan', parseInt(value, 10) < parseInt(comparisonModel, 10));
                }
                
                return value;
            };
            
            ctrl.$parsers.unshift(validate);

            ctrl.$formatters.push(validate);
            
            attr.$observe('lowerThan', (comparisonModel) => {
                
                return validate(ctrl.$viewValue);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/lower-than.directive.js